import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {getLoggedInUser} from '../utils/functions';
import {UserInfo} from '../types/interfaces';


type UiState = 'idle' | 'submitting' | 'success' | 'error';

export const AdminDeleteKyc: React.FC = () => {
    const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
    const [ui, setUi] = useState<UiState>('idle');
    const [msg, setMsg] = useState('');
    const [msisdn, setMsisdn] = useState('');
    const [comment, setComment] = useState('');
    const navigate = useNavigate();

    const API_BASE = process.env.REACT_APP_API_SELFCARE_URL as string;

    useEffect(() => {
        const init = async () => {
            const u = await getLoggedInUser();
            setUserInfo(u);
            if (!u) navigate('/error');
        };
        init();
    }, [navigate]);

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setUi('submitting');
        setMsg('');
        try {
            // Debug: confirm we're calling the proxy
            console.log('API_BASE', API_BASE);
            // eslint-disable-next-line no-console
            console.log('DELETE URL', `${API_BASE}/admin-ops/delete-kyc`);
            const res = await fetch(`${API_BASE}/admin-ops/delete-kyc`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json', 'token':`${userInfo?.token}`  },
                body: JSON.stringify({ msisdn, comment })
            });
            const raw = await res.text();
            let json: any = {};
            try { json = raw ? JSON.parse(raw) : {}; } catch (_e) { json = { message: raw }; }
            if (!res.ok) {
                setUi('error');
                setMsg(`${json.message || raw}`);
                return;
            }
            setUi('success');
            setMsg(`Number ${json.msisdn || ''} set to ${json.state || 'DEACTIVATED'}`);
            setMsisdn('');
        } catch (err: any) {
            setUi('error');
            setMsg(`Network error: ${err.message}`);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-8">
            <div className="max-w-2xl mx-auto bg-white rounded-lg shadow p-6">
                <h2 className="text-2xl font-bold text-green-800 mb-6">Delete KYC Number</h2>
                <div className="mb-6 p-4 bg-yellow-50 border-l-4 border-yellow-500 text-yellow-700">
                    <p className="text-sm"><strong>Warning:</strong> This action will deactivate the phone number. This action cannot be undone.</p>
                </div>
                {ui !== 'idle' && (
                    <div className={`mb-6 p-4 rounded-lg text-sm ${ui === 'success' ? 'bg-green-50 border-l-4 border-green-500 text-green-700' : 'bg-red-50 border-l-4 border-red-500 text-red-700'}`}>
                        {msg}
                    </div>
                )}
                <form onSubmit={onSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="msisdn" className="block text-sm font-medium text-green-700 mb-1">MSISDN</label>
                        <input 
                            id="msisdn"
                            value={msisdn} 
                            onChange={e => setMsisdn(e.target.value)} 
                            placeholder="Enter phone number"
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500" 
                            required 
                        />
                        <p className="mt-1 text-xs text-gray-500">Enter the phone number to deactivate (e.g. 73123456, 8901234567)</p>
                    </div>

                    <div>
                        <label htmlFor="comment" className="block text-sm font-medium text-green-700 mb-1">COMMENT</label>
                        <textarea
                            id="comment"
                            value={comment}
                            onChange={e => setComment(e.target.value)}
                            placeholder="State reason for deactivation"
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500"
                            required
                            rows={4}
                        />
                    </div>
                    <div className="flex gap-4 pt-4">
                        <button type="submit" disabled={ui === 'submitting'} className="flex-1 bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-md transition-colors">
                            {ui === 'submitting' ? (
                                <span className="flex items-center justify-center">
                                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Deactivating...
                                </span>
                            ) : 'Deactivate Number'}
                        </button>
                        <button type="button" onClick={() => navigate('/admin')} className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-3 rounded-md transition-colors">Back</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminDeleteKyc;

